import Vue from "vue";
import Vuex from "vuex";

import api from '../api/fixtures'
import apiClient from "../config/api.js";

const products = {
    state: {
        all: []
    }, mutations: {
        RECEIVE_PRODUCTS(state, products) {
            state.all = products
        }, REMOVE_FROM_CART(state, removedProduct) {
            state.all
                .find(product => product.id === removedProduct.id).inventory += removedProduct.quantity
        }
    }
}

const profile = {
    state: {
        data: {}
    }, mutations: {
        RECEIVE_PROFILE(state, profile) {
            state.data = profile
        },

        TOGGLE_COUPON(state, coupon) {
            const couponLimitId = 4

            if (coupon.id !== couponLimitId) return

            if (!coupon.active) {
                state.data.limit += 100
            } else {
                state.data.limit -= 100
            }
        }
    }
}


const promotions = {
    state: {
        all: []
    }, mutations: {
        RECEIVE_PROMOTIONS(state, promotions) {
            state.all = promotions
        },

        TOGGLE_COUPON(state, coupon) {
            coupon.active = !coupon.active
        }
    }
}

const shoppingCart = {
    state: {
        added: [], productDiscount: false, totalDiscount: false, freeShipping: false
    }, mutations: {
        ADD_TO_CART(state, productId) {
            const record = state.added.find(product => product.id === productId)

            if (!record) {
                state.added.push({
                    id: productId, quantity: 1
                })
            } else {
                record.quantity++
            }
        },

        REMOVE_FROM_CART(state, item) {
            const index = state.added.findIndex(added => added.id === item.id)
            state.added.splice(index, 1)
        },

        TOGGLE_COUPON(state, coupon) {
            const coupons = {
                '1': 'productDiscount', '2': 'totalDiscount', '3': 'freeShipping'
            }

            if (coupons[coupon.id]) {
                state[coupons[coupon.id]] = !state[coupons[coupon.id]]
            }
        }
    }
}

Vue.use(Vuex);

// Initialize user data from sessionStorage on app start
function initializeUserFromSession() {
    const token = sessionStorage.getItem('token');
    const userId = sessionStorage.getItem('userId');
    const userRole = sessionStorage.getItem('userRole');
    const brigade = sessionStorage.getItem('brigade');
    
    if (token && userId) {
        return {
            token: token,
            baseUrl: sessionStorage.getItem('baseUrl'),
            role: userRole,
            userId: userId,
            accountFirstname: sessionStorage.getItem('name') || '',
            accountLastname: sessionStorage.getItem('lastname') || '',
            brigade: brigade || '',
            companyName: sessionStorage.getItem('companyName') || '',
            companyId: sessionStorage.getItem('companyId'),
            accountId: sessionStorage.getItem('accountId'),
            email: sessionStorage.getItem('email') || ''
        };
    }
    return null;
}

export const store = new Vuex.Store({
    state: {
        user: initializeUserFromSession(), 
        loading: false, 
        error: null, 
        raisonabsence: null, 
        notification: "", 
        token: sessionStorage.getItem('token'),
    }, mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        }, setUser(state, payload) {
            state.user = payload;
        }, setNotification(state, payload) {
            state.notification = payload;
        }, setError(state, payload) {
            state.error = payload;
        }, logout(state) {
            state.user = null;
            state.token = null;
        }, clearError(state) {
            state.error = null;
        }, setRaisonsAbsences(state, payload) {
            state.raisonabsence = payload
        }
    }, actions: {
        getProfile({commit}) {
            api.getProfile(profile => {
                commit('RECEIVE_PROFILE', profile)
            })
        },

        getPromotions({commit}) {
            api.getPromotions(promotions => {
                commit('RECEIVE_PROMOTIONS', promotions)
            })
        },

        getProducts({commit}) {
            api.getProducts(products => {
                commit('RECEIVE_PRODUCTS', products)
            })
        },

        addToCart({commit}, product) {
            if (product.inventory > 0) {
                commit('ADD_TO_CART', product.id)
            }
        },

        removeFromCart({commit}, product) {
            commit('REMOVE_FROM_CART', product)
        },

        toggleCoupon({commit}, coupon) {
            commit('TOGGLE_COUPON', coupon)
        },

        loginUser({
                      commit
                  }, payload) {
            commit("setLoading", true);
            apiClient
                .post(`${payload.baseUrl}/auth/signin`, { // Pour Springboot 3 local
                    //.post(`${payload.baseUrl}/login`, { // Pour Springboot 2 prod
                    emailAddress: payload.emailAddress, password: payload.password
                })
                .then(response => {
                    if (response.data.status === 200) {
                        commit("setLoading", false);
                        commit("clearError");

                        let role, userId, firstname, lastname, brigade, companyId, companyName, accountId, email;
                        if (response.data.roles === null) { // FRONT
                            role = response.data.datas.roleName
                            userId = "front"
                            firstname = "front"
                            lastname = "Eyone"
                        } else {
                            role = response.data.account.userRoles
                            userId = response.data.account.userId
                            firstname = response.data.account.accountFirstname ? response.data.account.accountFirstname : ""
                            lastname = response.data.account.accountLastname ? response.data.account.accountLastname : ""
                            brigade = response.data.account.brigade ? response.data.account.brigade : ""
                            companyName = response.data.account.companyName ? response.data.account.companyName : ""
                            companyId = response.data.account.companyId
                            accountId = response.data.account.accountId
                            email = response.data.account.realAccountEmail
                        }

                        const newUser = {
                            role: role,
                            token: response.data.access_token,
                            baseUrl: payload.baseUrl,
                            userId: userId,
                            accountFirstname: firstname,
                            accountLastname: lastname,
                            brigade: brigade,
                            companyName: companyName,
                            companyId: companyId,
                            accountId: accountId,
                            email: email
                        };
                        sessionStorage.setItem("TimesMeals", JSON.stringify(["Déjeuner", "Diner"]))
                        sessionStorage.setItem("token", newUser.token);
                        sessionStorage.setItem("userRole", newUser.role)
                        sessionStorage.setItem('baseUrl', newUser.baseUrl)
                        sessionStorage.setItem('userId', newUser.userId)
                        sessionStorage.setItem('email', newUser.email)
                        sessionStorage.setItem('brigade', newUser.brigade)
                        sessionStorage.setItem('companyName', newUser.companyName)
                        sessionStorage.setItem('companyId', newUser.companyId)
                        sessionStorage.setItem('accountId', newUser.accountId)
                        sessionStorage.setItem('name', newUser.accountFirstname + ' ' + newUser.accountLastname + ' - ' + newUser.userId)
                        sessionStorage.setItem('nameShort', newUser.accountFirstname + ' ' + newUser.accountLastname)
                        sessionStorage.setItem("depthValChoosedd", "1")
                        sessionStorage.setItem("depthValChoosedt", "Profondeur Hier")
                        sessionStorage.setItem("heightValChoosedd", "0")
                        sessionStorage.setItem("heightValChoosedt", "Hauteur Aujourd'hui")
                        commit("setUser", newUser);

                        if (userId !== "front") {
                            apiClient
                                .get(`${payload.baseUrl}/account/absencetypes/` + sessionStorage.getItem("userId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let ArrayRaisons = []
                                    datas.forEach(item => {
                                        ArrayRaisons.push(item.type);
                                    });
                                    sessionStorage.setItem("RaisonsAbsences", JSON.stringify(ArrayRaisons))
                                    commit("setRaisonsAbsences", ArrayRaisons);
                                })
                                .catch(error => {
                                    console.log("store.absencetypes")
                                });

                            apiClient
                                .get(`${payload.baseUrl}/account/brigadetypes/` + sessionStorage.getItem("userId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let ArrayBrigades = []
                                    datas.forEach(item => {
                                        if (item.type.toUpperCase().toLocaleString() !== "INACTIF") {
                                            ArrayBrigades.push(item.type);
                                        }
                                    });
                                    sessionStorage.setItem("Brigades", JSON.stringify(ArrayBrigades))
                                })
                                .catch(error => {
                                    console.log("store.brigadetypes")
                                });

                            apiClient
                                .get(`${payload.baseUrl}/account/enableposts4rules/` + sessionStorage.getItem("userId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let ArrayPostes = []
                                    datas.forEach(item => {
                                        ArrayPostes.push(item.name);
                                    });

                                    ArrayPostes.sort()
                                    sessionStorage.setItem("Postes4rules", JSON.stringify(ArrayPostes))
                                })
                                .catch(error => {
                                    console.log("store.enableposts4rules")
                                });

                            apiClient
                                .get(`${payload.baseUrl}/account/categoriesagent/` + sessionStorage.getItem("userId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let ArrayCtgAgent = []
                                    datas.forEach(item => {
                                        ArrayCtgAgent.push(item.category);
                                        ArrayCtgAgent.push(item.contrainte);
                                    });

                                    ArrayCtgAgent.sort()
                                    sessionStorage.setItem("CategoriesAgent", JSON.stringify(ArrayCtgAgent))
                                })
                                .catch(error => {
                                    console.log("store.categoriesagent")
                                });

                            apiClient
                                .get(`${payload.baseUrl}/account/enableposts/` + sessionStorage.getItem("userId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let ArrayPostes = []
                                    datas.forEach(item => {
                                        if (item.name.toUpperCase().toLocaleString() !== "TOUS POSTES") {
                                            ArrayPostes.push(item.name);
                                        }
                                    });

                                    ArrayPostes.sort()
                                    sessionStorage.setItem("PostesEnabled", JSON.stringify(ArrayPostes))
                                })
                                .catch(error => {
                                    console.log("store.enableposts")
                                });

                            apiClient
                                .get(`${payload.baseUrl}/account/shifts/` + sessionStorage.getItem("userId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let Shifts = []
                                    datas.forEach(item => {
                                        Shifts.push(item.shiftName);
                                    });
                                    sessionStorage.setItem("Shifts", JSON.stringify(Shifts))
                                })
                                .catch(error => {
                                    console.log("store.shifts")
                                });

                            apiClient
                                .get(`${payload.baseUrl}/account/constantes/` + sessionStorage.getItem("userId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let Constantes = []
                                    datas.forEach(item => {
                                        Constantes.push(item.limitLateArrival);
                                        Constantes.push(item.limitEarlyDeparture);
                                        Constantes.push(item.limitInfOutsideShift);
                                        Constantes.push(item.limitSupOutsideShift);
                                    });
                                    sessionStorage.setItem("Constantes", JSON.stringify(Constantes))
                                })
                                .catch(error => {
                                    console.log("store.constantes")
                                });

                            apiClient
                                .get(`${payload.baseUrl}/account/roles/` + sessionStorage.getItem("userId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let ArrayRoles = []
                                    datas.forEach(item => {
                                        if (item.roleName !== "ADMINISTRATOR" && item.roleName !== "FRONT" && item.roleName !== "USER" && item.roleName !== "READER") ArrayRoles.push(item.roleName);
                                    });
                                    sessionStorage.setItem("Roles", JSON.stringify(ArrayRoles))
                                })
                                .catch(error => {
                                    console.log("store.roles")
                                });

                            if (sessionStorage.getItem("userId").toString().toLowerCase() !== "admin") {
                                apiClient
                                    .get(`${payload.baseUrl}/account/userInfos/` + sessionStorage.getItem("userId") + "/" + sessionStorage.getItem("userId"))
                                    .then(response => {
                                        let datas = response.data.data;
                                        let sigleRestaurateur = []

                                        datas.forEach(item => {
                                            sigleRestaurateur.push(item.accountLastname);
                                        });

                                        sessionStorage.setItem("sigleRestaurateur", JSON.stringify(sigleRestaurateur))
                                    })
                                    .catch(error => {
                                        console.log("store.userInfos")
                                    });
                            }

                            apiClient
                                .get(`${payload.baseUrl}/product/restaurateurs/` + sessionStorage.getItem("userId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let RestaurateursFull = []
                                    let Restaurateurs = []
                                    datas.forEach(item => {
                                        RestaurateursFull.push(item.sigle);
                                        RestaurateursFull.push(item.fullName);
                                        Restaurateurs.push(item.sigle);
                                    });

                                    sessionStorage.setItem("restaurateursFull", JSON.stringify(RestaurateursFull))
                                    sessionStorage.setItem("restaurateurs", JSON.stringify(Restaurateurs))
                                })
                                .catch(error => {
                                    console.log("store.restaurateurs")
                                });

                            apiClient
                                .get(`${payload.baseUrl}/wallet/get_wallet_only_companies/` + sessionStorage.getItem("accountId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let onlyCompaniesListFull = []
                                    let onlyCompaniesNamesList = []
                                    datas.forEach(item => {
                                        onlyCompaniesListFull.push(item.id, item.name);
                                        onlyCompaniesNamesList.push(item.name);
                                    });

                                    sessionStorage.setItem("onlyCompaniesListFull", JSON.stringify(onlyCompaniesListFull))
                                    sessionStorage.setItem("onlyCompaniesNamesList", JSON.stringify(onlyCompaniesNamesList))
                                })
                                .catch(error => {
                                    console.log("store.get_wallet_only_companies")
                                });

                            apiClient
                                .get(`${payload.baseUrl}/wallet/get_wallet_only_restaurants/` + sessionStorage.getItem("accountId"))
                                .then(response => {
                                    let datas = response.data.datas;
                                    let onlyRestaurantsListFull = []
                                    let onlyRestaurantsNamesList = []
                                    datas.forEach(item => {
                                        onlyRestaurantsListFull.push(item.id, item.name);
                                        onlyRestaurantsNamesList.push(item.name);
                                    });

                                    sessionStorage.setItem("onlyRestaurantsListFull", JSON.stringify(onlyRestaurantsListFull))
                                    sessionStorage.setItem("onlyRestaurantsNamesList", JSON.stringify(onlyRestaurantsNamesList))
                                })
                                .catch(error => {
                                    console.log("store.get_wallet_only_restaurants")
                                });
                        }
                    } else {
                        commit("setError", "Identifiants ou mot de passe incorrect!");
                        commit("setLoading", false);
                    }

                })
                .catch(error => {
                    commit("setError", "Serveur inaccessible.\nVérifiez votre internet.");
                    commit("setLoading", false);
                });
        },

        autoLogin({commit}, payload) {
            commit("setUser", {
                token: payload.token, role: payload.role, baseUrl: payload.baseUrl, userId: payload.userId,
            });
        }, logout({
                      commit
                  }) {
            commit("logout");
            sessionStorage.setItem("token", null);
            sessionStorage.removeItem("token");
            sessionStorage.removeItem('userRole')
            sessionStorage.removeItem("baseUrl")
            sessionStorage.removeItem("userId")
            sessionStorage.removeItem("brigade")
            sessionStorage.removeItem("companyName")
            sessionStorage.removeItem("companyId")
            sessionStorage.removeItem("accountId")
            sessionStorage.removeItem("name")
            sessionStorage.removeItem("depthValChoosedd")
            sessionStorage.removeItem("depthValChoosedt")
            sessionStorage.removeItem("heightValChoosedd")
            sessionStorage.removeItem("heightValChoosedt")
            sessionStorage.removeItem("RaisonsAbsences")
            sessionStorage.removeItem("Brigades")
            sessionStorage.removeItem("Postes4rules")
            sessionStorage.removeItem("PostesEnabled")
            sessionStorage.removeItem("Shifts")
            sessionStorage.removeItem("Constantes")
            sessionStorage.removeItem("Roles")
            sessionStorage.removeItem("TimesMeals")
            sessionStorage.removeItem("Status")
            sessionStorage.removeItem("Contracts")
            sessionStorage.removeItem("BusLines")
            sessionStorage.removeItem("Levels")
            sessionStorage.removeItem("ReasonsLeave")
            sessionStorage.removeItem("onlyCompaniesListFull")
            sessionStorage.removeItem("onlyCompaniesNamesList")
            sessionStorage.removeItem("onlyRestaurantsListFull")
            sessionStorage.removeItem("onlyRestaurantsNamesList")
            sessionStorage.removeItem("restaurateursFull")
            sessionStorage.removeItem("restaurateurs")
            sessionStorage.removeItem("sigleRestaurateur")
            sessionStorage.removeItem("email")
        }, getRaisonAbsence({commit}, payload) {

        }
    }, getters: {
        cartProducts(state) {
            let res = state.shoppingCart
            return res.added.map(({id, quantity}) => {
                const product = state
                    .products.all
                    .find(product => product.id === id)

                return {
                    ...product, quantity
                }
            })
        },

        itemsQuantity(state) {
            function cartProducts(state) {
                let res = state.shoppingCart
                return res.added.map(({id, quantity}) => {
                    const product = state
                        .products.all
                        .find(product => product.id === id)

                    return {
                        ...product, quantity
                    }
                })
            }

            let cp = cartProducts(state)
            return cp.reduce((quantity, item) => {
                return quantity + item.quantity
            }, 0)
        },

        subtotal(state) {
            const cartProducts = state => {
                let res = state.shoppingCart
                return res.added.map(({id, quantity}) => {
                    const product = state
                        .products.all
                        .find(product => product.id === id)

                    return {
                        ...product, quantity
                    }
                })
            };
            const sum = cartProducts(state).reduce((subtotal, item) => {
                return subtotal + item.price * item.quantity
            }, 0)

            return state.shoppingCart.productDiscount ? sum * 0.7 : sum
        },

        taxes(state) {
            const subtotal = state => {
                function cartProducts(state) {
                    let res = state.shoppingCart
                    return res.added.map(({id, quantity}) => {
                        const product = state
                            .products.all
                            .find(product => product.id === id)

                        return {
                            ...product, quantity
                        }
                    })
                }

                const sum = cartProducts(state).reduce((subtotal, item) => {
                    return subtotal + item.price * item.quantity
                }, 0)

                return state.shoppingCart.productDiscount ? sum * 0.7 : sum
            };
            return (subtotal(state) * 0.005)
        },

        shipping(state) {
            function cartProducts(state) {
                let res = state.shoppingCart
                return res.added.map(({id, quantity}) => {
                    const product = state
                        .products.all
                        .find(product => product.id === id)

                    return {
                        ...product, quantity
                    }
                })
            }

            const shippings = cartProducts(state).map(item => item.shipping)

            if (state.shoppingCart.freeShipping || !shippings.length) {
                return 0
            } else {
                return Math.max(...shippings)
            }
        },

        total(state) {
            function subtotal(state) {
                function cartProducts(state) {
                    let res = state.shoppingCart
                    return res.added.map(({id, quantity}) => {
                        const product = state
                            .products.all
                            .find(product => product.id === id)

                        return {
                            ...product, quantity
                        }
                    })
                }

                const sum = cartProducts(state).reduce((subtotal, item) => {
                    return subtotal + item.price * item.quantity
                }, 0)

                return state.shoppingCart.productDiscount ? sum * 0.7 : sum
            }

            function taxes(state) {
                function subtotal(state) {
                    function cartProducts(state) {
                        let res = state.shoppingCart
                        return res.added.map(({id, quantity}) => {
                            const product = state
                                .products.all
                                .find(product => product.id === id)

                            return {
                                ...product, quantity
                            }
                        })
                    }

                    const sum = cartProducts(state).reduce((subtotal, item) => {
                        return subtotal + item.price * item.quantity
                    }, 0)

                    return state.shoppingCart.productDiscount ? sum * 0.7 : sum
                }

                return (subtotal(state) * 0.005)
            }

            function shipping(state) {
                function cartProducts(state) {
                    let res = state.shoppingCart
                    return res.added.map(({id, quantity}) => {
                        const product = state
                            .products.all
                            .find(product => product.id === id)

                        return {
                            ...product, quantity
                        }
                    })
                }

                const shippings = cartProducts(state).map(item => item.shipping)

                if (state.shoppingCart.freeShipping || !shippings.length) {
                    return 0
                } else {
                    return Math.max(...shippings)
                }
            }

            const discout = state.shoppingCart.totalDiscount ? -100 : 0
            return subtotal(state) + taxes(state) + shipping(state) + discout
        },

        orderOnLimit(state) {
            function total(state) {
                function subtotal(state) {
                    function cartProducts(state) {
                        let res = state.shoppingCart
                        return res.added.map(({id, quantity}) => {
                            const product = state
                                .products.all
                                .find(product => product.id === id)

                            return {
                                ...product, quantity
                            }
                        })
                    }

                    const sum = cartProducts(state).reduce((subtotal, item) => {
                        return subtotal + item.price * item.quantity
                    }, 0)

                    return state.shoppingCart.productDiscount ? sum * 0.7 : sum
                }

                function taxes(state) {
                    function subtotal(state) {
                        function cartProducts(state) {
                            let res = state.shoppingCart
                            return res.added.map(({id, quantity}) => {
                                const product = state
                                    .products.all
                                    .find(product => product.id === id)

                                return {
                                    ...product, quantity
                                }
                            })
                        }

                        const sum = cartProducts(state).reduce((subtotal, item) => {
                            return subtotal + item.price * item.quantity
                        }, 0)

                        return state.shoppingCart.productDiscount ? sum * 0.7 : sum
                    }

                    return (subtotal(state) * 0.005)
                }

                function shipping(state) {
                    function cartProducts(state) {
                        let res = state.shoppingCart
                        return res.added.map(({id, quantity}) => {
                            const product = state
                                .products.all
                                .find(product => product.id === id)

                            return {
                                ...product, quantity
                            }
                        })
                    }

                    const shippings = cartProducts(state).map(item => item.shipping)

                    if (state.shoppingCart.freeShipping || !shippings.length) {
                        return 0
                    } else {
                        return Math.max(...shippings)
                    }
                }

                const discout = state.shoppingCart.totalDiscount ? -100 : 0
                return subtotal(state) + taxes(state) + shipping(state) + discout
            }

            let result = false
            let limit = state.profile.data.limit
            if (limit !== undefined) {
                result = limit <= total(state)
            }

            return result
        },

        isAuthenticated(state) {
            return (!(state.token === null || state.token || 0 === state.token.length || /^\s*$/.test(state.token)));
        }, loading(state) {
            return state.loading;
        }, error(state) {
            return state.error;
        }, user(state) {
            return state.user;
        }, raisonabsence(state) {
            return state.raisonabsence
        }, notification: state => {
            return state.notification
        }, token(state) {
            return state.token
        }
    },

    modules: {
        products, profile, promotions, shoppingCart
    },
});
